module.exports = __webpack_public_path__ + "img/404.d978db80.svg";